import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SettingsService } from "../../../core/settings/settings.service";

@Component({
  selector: "app-modals",
  templateUrl: "./modals.html",
  styleUrls: ["./modals.scss"]
})
export class ModalsComponent implements OnInit, OnDestroy {
  @ViewChild("settingsPonds") settingsPonds: ElementRef;
  @ViewChild("gatewayFormModal", { static: true }) gatewayFormModal: TemplateRef<any>;

  /** Configuracion estandar de los modales de formulario. */
  configModal: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    centered: true,
    size: "lg",
    windowClass: "modal-config modal-sheet"
  };

  private gatewayModalRef: NgbModalRef | null = null;
  private destroy$ = new Subject<void>();

  constructor(public Settings: SettingsService, private modalService: NgbModal) {}

  count = 0;
  // @HostListener("document:click", ["$event"])
  // clickout(event) {
  //   if (this.Settings.settingsPonds.status) {
  //     if (!this.settingsPonds.nativeElement.contains(event.target)) {
  //       this.count++;
  //       if (this.count > 1) {
  //         this.Settings.settingsPonds = {
  //           status: false,
  //           listSelected: [],
  //         };
  //       }
  //       if (this.count >= 2) {
  //         this.count = 0;
  //       }
  //     }
  //   }
  // }
  /** Abre o cierra el modal del formulario de gateway segun su estado en SettingsService. */
  ngOnInit(): void {
    this.Settings.gatewayFormStatus$.pipe(takeUntil(this.destroy$)).subscribe((status) => {
      this.Modal(this.gatewayFormModal, status ? "show" : "hide");
    });
  }

  /** Cierra el modal abierto y libera la suscripcion. */
  ngOnDestroy(): void {
    this.Modal(this.gatewayFormModal, "hide");
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Muestra u oculta el modal del formulario de gateway.
   * @param template plantilla del modal.
   * @param type "show" para abrir, "hide" para cerrar.
   */
  Modal = (template: TemplateRef<any>, type: "show" | "hide") => {
    switch (type) {
      case "show":
        if (this.gatewayModalRef) {
          return;
        }
        this.gatewayModalRef = this.modalService.open(template, this.configModal);
        // Si otro componente cierra todos los modales (dismissAll), se limpia el estado
        this.gatewayModalRef.result.then(
          () => this.onGatewayModalClosed(),
          () => this.onGatewayModalClosed()
        );
        break;
      case "hide":
        if (this.gatewayModalRef) {
          this.gatewayModalRef.close();
        }
        break;
      default:
    }
  };

  /** Deja el formulario de gateway cerrado cuando el modal se cierra por cualquier via. */
  private onGatewayModalClosed(): void {
    this.gatewayModalRef = null;
    if (!this.Settings.GatewayForm.status) {
      return;
    }
    this.Settings.GatewayForm = {
      ...this.Settings.GatewayForm,
      farm: null,
      status: false,
      gateway: null
    };
  }

  validateModal() {
    let arr = [this.Settings.settingsPonds.status, this.Settings.TesteoGateway.status];

    return arr.some((bool) => bool == true);
  }
}
